import React from 'react'

export default function HomeTwoTeam() {
    return (
        <>
            {/* <!-- team section start --> */}
            <div className="team-section blue-bg pt-100 pb-100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8 text-center">
                            <div className="section-header mb-65">
                                <h4 className="sub-heading sub-heading__2 sub-heading__white   mb-15">
                                    <span><img src="/images/shape/heading-shape-3.png" className="mr-5" alt="" /></span>
                                    team member
                                    <span><img src="/images/shape/heading-shape-4.png" className="ml-5" alt="" /></span>
                                </h4>
                                <h2 className="section-title section-title__2 section-title__white">Executive Team</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-none-40">
                        <div className="col-xl-4 col-lg-6 col-md-6 mt-40">
                            <div className="team-box">
                                <div className="team-box__thumb">
                                    <img src="/images/team/team-1.jpeg" alt="" />
                                </div>
                                <div className="team-box__content">
                                    <h4 className="name">Mr. XYZ</h4>
                                    <span className="designation">Project Manager</span>
                                    <div className="social-links">
                                        <a href="#0"><i className="fab fa-facebook-f"></i></a>
                                        <a href="#0"><i className="fab fa-twitter"></i></a>
                                        <a href="#0"><i className="fab fa-pinterest-p"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 mt-40">
                            <div className="team-box">
                                <div className="team-box__thumb">
                                    <img src="/images/team/team-2.jpeg" alt="" />
                                </div>
                                <div className="team-box__content">
                                    <h4 className="name">Mr. XYZ</h4>
                                    <span className="designation">Project Manager</span>
                                    <div className="social-links">
                                        <a href="#0"><i className="fab fa-facebook-f"></i></a>
                                        <a href="#0"><i className="fab fa-twitter"></i></a>
                                        <a href="#0"><i className="fab fa-pinterest-p"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 mt-40">
                            <div className="team-box">
                                <div className="team-box__thumb">
                                    <img src="/images/team/team-3.jpeg" alt="" />
                                </div>
                                <div className="team-box__content">
                                    <h4 className="name">Mr. XYZ</h4>
                                    <span className="designation">Project Manager</span>
                                    <div className="social-links">
                                        <a href="#0"><i className="fab fa-facebook-f"></i></a>
                                        <a href="#0"><i className="fab fa-twitter"></i></a>
                                        <a href="#0"><i className="fab fa-pinterest-p"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- team section end -->    */}
        </>
    )
}
